<template>
  <div>
    <custom-draw width="65%" :title="model.title" :visible="visible" v-on="$listeners">
      <div class="bill-draw-body">
        <div class="aside">
          <h1>{{ $t('crm_contract_lease_detail.fajbxx') }}</h1>
          <ul>
            <li>
              <div class="line1">{{ $t('crm_contract_lease_detail.fang_an_ming_cheng') }}</div>
              <div class="text-right">{{ detail.goodsName }}</div>
            </li>
            <li>
              <div class="line1">{{ $t('crm_contract_lease_detail.fang_an_bian_hao') }}</div>
              <div class="text-right">{{ detail.goodsCode }}</div>
            </li>
            <li>
              <div class="line1">{{ $t('crm_contract_lease_detail.fang_an_lei_xing') }}</div>
              <div class="text-right">{{ detail.categoryName }}</div>
            </li>
            <li>
              <div class="line1">{{ $t('crm_contract_lease_detail.chan_pin_xing_hao') }}</div>
              <div class="text-right">{{ detail.productCode }}</div>
            </li>
            <li>
              <div class="line1">{{ $t('crm_contract_lease_detail.chan_pin_ming_cheng') }}</div>
              <div class="text-right">{{ detail.productName }}</div>
            </li>
            <li>
              <div class="line1">{{ $t('crm_contract_lease_detail.zu_zhi_lei_xing') }}</div>
              <div class="text-right" v-if="detail.goodsSkuOwner">
                {{
                  detail.goodsSkuOwner
                    .split(',')
                    .map((t) => getDicValue('crm_scheme_owner', t))
                    .join('，')
                }}
              </div>
            </li>
            <li>
              <div class="line1">{{ $t('crm_contract_lease_detail.fang_an_miao_shu') }}</div>
              <div class="text-right">{{ detail.goodsDesc }}</div>
            </li>
          </ul>
        </div>
        <div class="draw-section" style="padding: 0; display: block; border-top: 1px solid #eef2f8">
          <custom-tab :list="tabList" v-model="tabIndex" class="tab"></custom-tab>
          <!-- 服务区域 -->
          <div v-if="tabIndex === 'area'" style="padding: 24px">
            <div class="item-title">{{ $t('crm_contract_lease_detail.shi_yong_gong_si') }}</div>
            <span v-for="(item, index) in orgList" :key="index" class="area-item">
              {{ item }}
            </span>
          </div>
          <!-- 分成方案 -->
          <div v-if="tabIndex === 'goods'" style="padding: 24px; overflow: auto;">
            <div class="table-bd">
              <custom-table
                tableCode="leaseManage"
                :default-expand-all="true"
                :index="true"
                :expand="true"
                :data="tableList"
                :column="tableColumn"
                @sort="sortChange"
                @filter="filterChange"
                :slots="['rentalTermMin', 'custom1', 'custom2', 'custom3', 'custom4', 'action']"
              >
                <template slot="expand" slot-scope="scope">
                  <el-table :size="allTableSize" :data="scope.row.sharingList" style="width: 100%">
                    <el-table-column prop="sharingClass" :label="$t('crm_contract_lease_detail.fen_cheng_fang_an')" width="100"></el-table-column>
                    <el-table-column :label="$t('crm_contract_lease_detail.jfdbysy')" width="200">
                      <template slot-scope="scope">
                        <span>{{ scope.row.agentCoProfit }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column :label="$t('crm_contract_lease_detail.shgsysy')" width="200">
                      <template slot-scope="scope">
                        <span>{{ scope.row.afterServiceProfit }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column :label="$t('crm_contract_lease_detail.zbysy')" width="200">
                      <template slot-scope="scope">
                        <span>{{ scope.row.hqProfit }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column :label="$t('crm_contract_lease_detail.zbysjzy')" width="200">
                      <template slot-scope="scope">
                        <span>{{ scope.row.hqBasicProfit }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column :label="$t('crm_contract_lease_detail.shou_qi_fen_cheng')">
                      <template slot-scope="scope">
                        <span>{{ getDicValue('isynergy_cloud_bool', `${scope.row.isFirstTerm}`) }}</span>
                      </template>
                    </el-table-column>
                  </el-table>
                </template>
                <template slot="rentalTermMin" slot-scope="scope">{{ scope.row.rentalTermMin }} - {{ scope.row.rentalTermMax }}</template>
                <!-- 押金 -->
                <template slot="custom1" slot-scope="scope">
                  <span>{{ scope.row.depositFee }}</span>
                </template>
                <!-- 租金 -->
                <template slot="custom2" slot-scope="scope">
                  <span>{{ scope.row.unitPrice }}</span>
                </template>
                <!-- 售后附加费 -->
                <template slot="custom3" slot-scope="scope">
                  <span>{{ scope.row.additionalFee }}</span>
                </template>
                <!-- 赠送月数 -->
                <template slot="custom4" slot-scope="scope">
                  <span>{{ scope.row.giveawayMonth }}</span>
                </template>
                <template slot="action" slot-scope="scope">
                  <span></span>
                  <el-button type="text" size="mini" @click="onPreviewDialog(scope.row)">{{ $t('crm_contract_lease_detail.yu_lan') }}</el-button>
                  <el-button type="text" size="mini" @click="onPreviewBreakDialog(scope.row)">{{ $t('crm_contract_lease_detail.ckwyfa') }}</el-button>
                </template>
              </custom-table>
            </div>
          </div>
          <!-- 方案合同 -->
          <div v-if="tabIndex === 'contract'" style="padding: 24px; overflow: auto;">
            <custom-table tableCode="goodsContract" :index="true" :data="contractList" :column="tableColumn" @sort="sortChange" @filter="filterChange"></custom-table>
            <div class="table-page">
              <custom-page :total="totalRows" :page="pageNum" :size="pageSize" @change="onPageChange"></custom-page>
            </div>
          </div>
        </div>
        <div slot="footer" class="footer">
          <el-button size="small" type="primary" @click="visible = false">{{ $t('Common.com_close') }}</el-button>
        </div>
      </div>
    </custom-draw>
    <step-manage-preview-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false"></step-manage-preview-dialog>
    <!-- 查看违约方案 -->
    <step-manage-falsify-dialog v-if="dialogVisible2" :model="dialogModel2" @close="dialogVisible2 = false"></step-manage-falsify-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins.js';
import stepManagePreviewDialog from '@/pages/crm/components/managePreviewDialog';
import stepManageFalsifyDialog from '@/pages/crm/contractLeaseItem/children/step_manage_falsify_dialog';

export default {
  mixins: [dialogMixins],
  components: { stepManagePreviewDialog, stepManageFalsifyDialog },
  data() {
    return {
      tableCode: 'leaseManage',
      tabIndex: 'area',
      orgList: [],
      tableList: [],
      ruleList: [],
      detail: {},
      form: {
        goodsId: '',
        organList: [],
        productCode: '',
        productName: '',
        erpCode: '',
        erpName: '',
        unit: '',
        categoryId: '',
        goodsCode: '',
        goodsDesc: '',
        goodsName: '',
        modelName: '',
      },

      pageNum: 0,
      pageSize: 50,
      totalRows: null,
      contractList: [],
      dialogVisible: false,
      dialogModel: {},
      dialogVisible2: false,
      dialogModel2: {},
    };
  },
  computed: {
    tabList() {
      return [
        {
          name: this.$t('crm_contract_lease_detail.shi_yong_gong_si'),
          value: 'area',
        },
        {
          name: this.$t('crm_contract_lease_detail.fen_cheng_fang_an'),
          value: 'goods',
        },
        {
          name: this.$t('crm_contract_lease_detail.fu_wu_he_tong'),
          value: 'contract',
        },
      ];
    },
  },
  mounted() {
    this.getGoodsInfo();
    this.getGoodsContract();
    // this.getDictionary('crm_sharing_rule_type', () => {
    //   const ruleTypes = this.propertyMap.crm_sharing_rule_type;
    //   this.itemsForm = ruleTypes.map((t) => Object.assign({}, this.form, { sharingClass: t.value }));
    //   this.getTableList();
    // });
    this.getSharingRuleList(() => {
      this.itemsForm = this.ruleList.map((t) => {
        const obj = { sharingClass: t.sharingClass, sharingCondition: t.sharingCondition, sharingConditionView: t.sharingConditionView, firstDeviceBizType: [] };
        return Object.assign({}, this.form, obj);
      });
      this.getTableList();
    });
  },
  methods: {
    // 预览
    onPreviewDialog: function (data) {
      this.dialogModel.title = this.$t('crm_contract_lease_detail.fen_cheng_ming_xi');
      this.dialogModel.data = { row: data };
      this.dialogVisible = true;
    },
    // 查看违约方案
    onPreviewBreakDialog(data) {
      this.dialogModel2.type = 'watch';
      this.dialogModel2.title = this.$t('crm_contract_lease_detail.ckwyfa');
      this.dialogModel2.data = { row: data };
      this.dialogVisible2 = true;
    },
    // 获取方案信息
    getGoodsInfo: function () {
      this.$getJSON(apis.GoodsInfo, { goodsId: this.model.row.goodsId }).then((res) => {
        const result = res.data;
        this.detail = result;
        this.$setFormatData(this.form, result);
        this.orgList = this.form.organList.map((t) => t.orgName);
      });
    },
    // 获取分成规则
    getSharingRuleList: function (cb) {
      this.$getJSON(apis.sharingRuleList, { productCode: this.model.row.productCode.split(',')[0] }).then((res) => {
        this.ruleList = res.data;
        cb();
      });
    },
    // 获取方案列表
    getTableList: function () {
      this.$getJSON(apis.GoodsSkuList, { goodsId: this.model.row.goodsId }).then((res) => {
        const list = res.data;
        const arr = [];
        list.forEach((item) => {
          // 绑住值 如果数据存在（预防字典更新）/ 数据不存在
          if (item.sharingList) {
            const sharingList = [];
            this.ruleList.forEach((dic) => {
              const val = item.sharingList.find((f) => f.sharingClass === dic.sharingClass);
              sharingList.push(val || Object.assign({}, this.form, { sharingClass: dic.sharingClass }));
            });
            item.sharingList = sharingList;
          } else {
            item.sharingList = JSON.parse(JSON.stringify(this.itemsForm));
          }
          // 融合旧数据
          const row = this.tableList.find((t) => t.goodsSkuId === item.goodsSkuId);
          arr.push(row || item);
        });
        this.tableList = arr;
      });
    },
    // 获取方案合同
    getGoodsContract() {
      this.$getJSON(apis.OrderGoodsContract, {
        goodsId: this.model.row.goodsId,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      }).then((res) => {
        this.contractList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.pageNum = page;
      this.pageSize = size || this.formSearch.pageSize;
      this.getGoodsContract();
    },
  },
};
</script>

<style lang="scss">
.el-drawer__body {
  height: 0;
}
.bill-draw-body {
  display: flex;
  height: 100%;
  position: relative;
  .aside {
    flex: 0 0 280px;
    padding: 0 16px;
    height: 100%;
    background: #f8f9fb;
    overflow-y: auto;
    h1 {
      line-height: 60px;
      height: 60px;
      color: #495057;
      font-size: 14px;
    }
    ul > li {
      line-height: 34px;
      font-size: 12px;
      display: flex;
      justify-content: space-between;
      color: #6c757d;
      box-shadow: 0px -1px 0px 0px #eef2f7;
      & > div:first-child {
        margin-right: 20px;
      }
      .text-right {
        text-align: right;
        flex: 1;
        line-height: 20px;
        padding: 7px 0;
      }
    }
  }
  .draw-section {
    flex: 1;
    width: 0;
    overflow: hidden;
    height: calc(100% - 24px);
    padding: 24px 0 72px;
    position: relative;
    display: flex;
    h1 {
      line-height: 50px;
      height: 50px;
      color: #495057;
      font-size: 13px;
    }
    & > .ub-f1:first-child {
      box-shadow: 1px 0px 0px 0px #e9ebec;
    }
    .ub-f1 {
      width: 0;
      padding: 0 14px;
    }
    .area-item {
      height: 40px;
      line-height: 40px;
      display: inline-block;
      padding: 0 28px;
      background: #f8f9fb;
      margin-right: 20px;
      margin-bottom: 20px;
      font-size: 14px;
      color: #404040;
    }
  }
  .footer {
    position: absolute;
    box-shadow: 0px -1px 0px 0px rgba(238, 242, 248, 1);
    left: 280px;
    right: 0;
    bottom: 0;
    height: 60px;
    z-index: 999;
    padding-top: 16px;
    padding-left: 24px;
    padding-right: 24px;
    background-color: #ffffff;
    text-align: right;
  }
}
</style>
